module.exports = __webpack_public_path__ + "static/media/WebAppConfigSample_489x295.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/CustomizeGlobalIdpSettings/WebAppConfigSample_489x295.png
// module id = 1222
// module chunks = 0